import { render, staticRenderFns } from "./handoverFormDialog.vue?vue&type=template&id=6c1c9764&scoped=true"
import script from "./handoverFormDialog.vue?vue&type=script&lang=js"
export * from "./handoverFormDialog.vue?vue&type=script&lang=js"
import style0 from "./handoverFormDialog.vue?vue&type=style&index=0&id=6c1c9764&prod&lang=scss&scoped=true"
import style1 from "./handoverFormDialog.vue?vue&type=style&index=1&id=6c1c9764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c9764",
  null
  
)

export default component.exports